export const MASTER_TEST_UNIT_EDIT_FIELDS = {
    TEST_NAME: "testName",
    UNIT: 'unit',
    MAIN_TEST: "mainTest",
} 